export * from './absence.service';
import { AbsenceService } from './absence.service';
export * from './absence.serviceInterface'
export * from './absenceV2.service';
import { AbsenceV2Service } from './absenceV2.service';
export * from './absenceV2.serviceInterface'
export * from './application.service';
import { ApplicationService } from './application.service';
export * from './application.serviceInterface'
export * from './attendant.service';
import { AttendantService } from './attendant.service';
export * from './attendant.serviceInterface'
export * from './authentication.service';
import { AuthenticationService } from './authentication.service';
export * from './authentication.serviceInterface'
export * from './callControl.service';
import { CallControlService } from './callControl.service';
export * from './callControl.serviceInterface'
export * from './conference.service';
import { ConferenceService } from './conference.service';
export * from './conference.serviceInterface'
export * from './configuration.service';
import { ConfigurationService } from './configuration.service';
export * from './configuration.serviceInterface'
export * from './customerNotification.service';
import { CustomerNotificationService } from './customerNotification.service';
export * from './customerNotification.serviceInterface'
export * from './directory.service';
import { DirectoryService } from './directory.service';
export * from './directory.serviceInterface'
export * from './directoryV2.service';
import { DirectoryV2Service } from './directoryV2.service';
export * from './directoryV2.serviceInterface'
export * from './lync.service';
import { LyncService } from './lync.service';
export * from './lync.serviceInterface'
export * from './mediaAdministration.service';
import { MediaAdministrationService } from './mediaAdministration.service';
export * from './mediaAdministration.serviceInterface'
export * from './messaging.service';
import { MessagingService } from './messaging.service';
export * from './messaging.serviceInterface'
export * from './nameValue.service';
import { NameValueService } from './nameValue.service';
export * from './nameValue.serviceInterface'
export * from './pushSubscription.service';
import { PushSubscriptionService } from './pushSubscription.service';
export * from './pushSubscription.serviceInterface'
export * from './queueControl.service';
import { QueueControlService } from './queueControl.service';
export * from './queueControl.serviceInterface'
export * from './serviceAdministration.service';
import { ServiceAdministrationService } from './serviceAdministration.service';
export * from './serviceAdministration.serviceInterface'
export * from './settings.service';
import { SettingsService } from './settings.service';
export * from './settings.serviceInterface'
export * from './statstics.service';
import { StatsticsService } from './statstics.service';
export * from './statstics.serviceInterface'
export * from './support.service';
import { SupportService } from './support.service';
export * from './support.serviceInterface'
export * from './synchronization.service';
import { SynchronizationService } from './synchronization.service';
export * from './synchronization.serviceInterface'
export * from './whitepages.service';
import { WhitepagesService } from './whitepages.service';
export * from './whitepages.serviceInterface'
export const APIS = [AbsenceService, AbsenceV2Service, ApplicationService, AttendantService, AuthenticationService, CallControlService, ConferenceService, ConfigurationService, CustomerNotificationService, DirectoryService, DirectoryV2Service, LyncService, MediaAdministrationService, MessagingService, NameValueService, PushSubscriptionService, QueueControlService, ServiceAdministrationService, SettingsService, StatsticsService, SupportService, SynchronizationService, WhitepagesService];
